import { useEffect, useRef, useState } from "react";
import Image from "next/image";

import bgImg from "../../../../public/images/t19bg.png";
import defaultImage from "../../../../public/images/image20.jpeg";

type Props = {
  sectionImage?: string;
};

const Quotes: React.FC<Props> = ({ sectionImage }) => {
  const text =
    "My heart is yours to hold and cherish for the rest of our days.";
  const [displayed, setDisplayed] = useState("");
  const [typing, setTyping] = useState(true);
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !inView) {
          setInView(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [inView]);

  useEffect(() => {
    if (!inView) return;

    setDisplayed("");
    setTyping(true);
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed((prev) => prev + text[i]);
      i++;
      if (i >= text.length) {
        clearInterval(interval);
        setTyping(false);
      }
    }, 30);
    return () => clearInterval(interval);
  }, [inView]);

  return (
    <div className="w-full h-[100vh] flex flex-col lg:flex-row">
      {/* Quote Content Section - First on mobile, second on desktop */}
      <div className="flex-1 h-1/2 lg:h-full relative order-1 lg:order-2">
        {/* Background image */}
        <div className="absolute inset-0">
          <Image
            src={bgImg}
            alt="background"
            layout="fill"
            className="object-cover object-center"
          />
        </div>

        {/* Quote content with golden quotes background overlay */}
        <div
          ref={containerRef}
          className="relative z-10 h-full flex justify-center items-center px-6 lg:px-8"
          style={{
            background: `
              url('/images/golden-quotes.png')
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="flex flex-col justify-center items-center w-full relative z-10">
            <h3 className="font-ntFab font-semibold lg:font-normal text-3xl lg:text-5xl xl:text-6xl 2xl:text-7xl max-w-xs lg:max-w-xl leading-[3rem] xl:leading-[7rem] text-center text-[#FCE2B0]">
              {displayed}
              {typing && <span className="animate-pulse">|</span>}
            </h3>
          </div>
        </div>
      </div>

      {/* Image Section - Second on mobile, first on desktop */}
      <div className="flex-1 h-1/2 lg:h-full min-h-[50vh] order-2 lg:order-1 lg:hidden">
        <div className="relative w-full h-full">
          <Image
            loading="eager"
            layout="fill"
            src={sectionImage || defaultImage}
            alt="romantic-quote-image"
            className="object-cover object-center lg:object-top"
            sizes="(max-width: 1024px) 100vw, 50vw"
          />
        </div>
      </div>
    </div>
  );
};

export default Quotes;
